export const excludeUser = {
  organization_demo: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  demo_company: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  UBS: {
    'basket to index conversion': 'hidden',
  },
  'UBS APAC': {
    'basket to index conversion': 'hidden',
  },
  'UBS EMEA': {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  'UBS EMEA D1': {
    'basket to index conversion': 'hidden',
  },
  'UBS EMEA AMC': {
    'basket to index conversion': 'hidden',
  },
  BNP: {
    'factsheet builder': 'hidden',
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  Ultumus: {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  'Ultumus UAT': {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  MV_PD: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
    'rebalancing & reconstitution': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  MV_OPS: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
    'rebalancing & reconstitution': 'hidden',
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  MV_CA: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
    'rebalancing & reconstitution': 'hidden',
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  'Morgan Stanley': {
    'basket to index conversion': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  MarketVectorSandbox: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
    'rebalancing & reconstitution': 'hidden',
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  BITASandbox: {},
  Barclays: {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  'RBC-D1-AMER': {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  'RBC-SP-AMER': {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  'Cantor Fitzgerald': {
    'basket to index conversion': 'hidden',
  },
  'CIBC-SP-AMER': {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'bulk basket update/edition': 'hidden',
  },
  'Clear Street Americas': {
    'basket to index conversion': 'hidden',
  },
};
